<template>
  <v-row>
    <v-col>
      <v-navigation-drawer
        permanent
        absolute
        floating
        expand-on-hover
        :mini-variant="$vuetify.breakpoint.mobile"
        :mini-variant-width="!$vuetify.breakpoint.mobile ? 56 : 40"
        right
        class="elevation-1 mt-n4"
        style="position: fixed; padding-top: 110px"
      >
        <v-list nav dense>
          <v-list-item
            v-if="!ps.is_paid"
            @click="generateInscriptionPdf('all')"
          >
            <v-list-item-icon>
              <v-icon color="red">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar lista de inscritos
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="ps.is_paid" @click="generateConfirmedInscriptions">
            <v-list-item-icon>
              <v-icon color="red">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar lista de inscritos
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportDialog = true">
            <v-list-item-icon>
              <v-icon color="green">mdi-file-excel</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Exportar para excel
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              isAdmin &&
              ((ps.avaliationData && ps.avaliationData.length > 0) ||
                (ps.bonifications && ps.bonifications.length > 0))
            "
            @click="generateInscriptionPdf('all', true)"
          >
            <v-list-item-icon>
              <v-icon color="red">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar lista de bonificações
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="generateInscriptionReport">
            <v-list-item-icon>
              <v-icon color="red">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar relatório de inscritos
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              isAdmin &&
              ((ps.avaliationData && ps.avaliationData.length > 0) ||
                (ps.bonifications && ps.bonifications.length > 0))
            "
            @click="openConfirmDialog"
            :disabled="loadingDialog"
          >
            <v-list-item-icon>
              <v-icon color="purple">mdi-file-send</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Distribuir avaliações de bonificação
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="isAdmin && ps.bonifications && ps.bonifications.length > 0"
            @click="setEnemGradesDialog = true"
          >
            <v-list-item-icon>
              <v-icon color="blue">mdi-file-import</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Importar notas do ENEM
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="isAdmin && ps.bonifications && ps.bonifications.length > 0"
            @click="generateNoGradeXlsx"
          >
            <v-list-item-icon>
              <v-icon color="green">mdi-file-excel</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar lista de candidatos sem nota
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="ps.has_isencao"
            @click="generateInscriptionPdf('wants_isencao')"
          >
            <v-list-item-icon>
              <v-icon color="red">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar isenções solicitadas
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="ps.has_isencao"
            @click="generateInscriptionPdf('accepted_isencao')"
          >
            <v-list-item-icon>
              <v-icon color="red">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Baixar lista de isenções aceitas
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="isAdmin && ps.is_paid"
            @click="paymentDialog = true"
          >
            <v-list-item-icon>
              <v-icon color="blue">mdi-file-import</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Importar Dados de Pagamento
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isAdmin" @click="consolidaDialog = true">
            <v-list-item-icon>
              <v-icon color="blue">mdi-file-import</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="white-space: initial; cursor: pointer">
              Consolidar Resultados
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-card
        :class="!$vuetify.breakpoint.mobile ? 'mr-14' : 'mr-9'"
        elevation="0"
      >
        <v-toolbar dense elevation="1">
          <v-toolbar-title
            title
            :class="$vuetify.breakpoint.mobile ? 'toolbar-title-mobile' : ''"
          >
            Candidatos inscritos: {{ ps.title }}
          </v-toolbar-title>
        </v-toolbar>

        <div class="row">
          <v-col>
            <v-data-table
              :class="
                !$vuetify.breakpoint.mobile
                  ? 'row-pointer'
                  : 'row-pointer-mobile'
              "
              :options.sync="tableOptions"
              :headers="headersTest"
              :items="inscriptionsInTable"
              :search="search"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              multi-sort
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageOptions: [25, 50, 100, -1],
              }"
              @click:row="inscriptionDetails"
            >
              <template v-slot:top>
                <v-text-field
                  dense
                  outlined
                  hide-details="auto"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar por candidato"
                  single-line
                  class="mx-auto px-4 pt-5"
                  style="margin-right: 100px"
                ></v-text-field>

                <div>
                  <v-select
                    class="py-5 px-4"
                    dense
                    outlined
                    hide-details="auto"
                    label="Mostrar APENAS os candidatos do curso de"
                    v-model="filters.course"
                    :items="courses"
                  ></v-select>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </div>
        <v-divider class="pb-3"></v-divider>
      </v-card>
      <LoadingDialog v-if="loadingDialog" :loading="loadingDialog" />
      <ExportDialog
        v-if="exportDialog"
        :dialog="exportDialog"
        @close="exportDialog = false"
        :inscriptions="inscriptions"
        :ps="ps"
      />
      <InsertPaymentDialog
        :dialog="paymentDialog"
        :ps="ps"
        @close="paymentDialog = false"
      />
      <ConsolidaResultadosDialog
        :dialog="consolidaDialog"
        :ps="ps"
        @close="consolidaDialog = false"
      />
      <SetEnemGradesDialog
        v-if="setEnemGradesDialog"
        @close="setEnemGradesDialog = false"
        :dialog="setEnemGradesDialog"
        :ps="ps"
      />
      <ConfirmDialog
        v-if="confirmDialog"
        :dialog="confirmDialog"
        @close="confirmDialog = false"
        @result="setAvaliatorsAuto"
      />
    </v-col>
  </v-row>
</template>
<script>
import generateInscriptionPdf from "../services/generateInscriptionPdf";
import generateConfirmedInscriptionsPdf from "../services/generateConfirmedInscriptionsPdf";
import generateInscriptionReport from "../services/generateInscriptionReport";
import inscriptionReportPaidPdf from "../services/inscriptionReportPaidPdf";
import generateResultadoTecnico from "../services/generateResultadoTecnico";
import SetEnemGradesDialog from "@/components/SetEnemGradesDialog.vue";
import LoadingDialog from "@/components/LoadingDialog.vue";
import { mapState, mapGetters } from "vuex";
import {app} from "../services/feathers";
import sortArray from "sort-array";
import xlsx from "xlsx";
import { saveAs } from "file-saver";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import InsertPaymentDialog from "../components/InsertPaymentDialog.vue";
import ConsolidaResultadosDialog from "../components/ConsolidaResultadosDialog.vue";
import { firstBy } from "thenby";
import ExportDialog from "../components/ExportDialog.vue";

export default {
  metaInfo() {
    return { title: `Inscritos - ${this.ps.title}` };
  },
  computed: {
    ...mapState("auth", ["user", "token"]),
    ...mapGetters("auth", ["isAuthenticated", "isAdmin", "isStaff"]),
    headersTest() {
      // model. text
      let headers = this.headersAux.filter((header) => {
        return header.model;
      });

      return headers;
    },
    inscriptionsInTable: function () {
      let inscriptions = this.inscriptions;
      if (this.onlyBonifications) {
        inscriptions = inscriptions.filter(
          (e) => e.bonification.multiplier > 1
        );
      }
      if (this.notAnsweredBonifications) {
        inscriptions = inscriptions.filter(
          (e) => e.bonification_text === undefined
        );
      }
      if (
        this.filters.course !== "Todos" &&
        this.filters.course !== undefined
      ) {
        inscriptions = inscriptions.filter((e) => {
          return e.course === this.filters.course;
          // return e.course.title === this.filters.course;
        });
      }
      if (this.only_homologated) {
        inscriptions = inscriptions.filter(
          (e) => e.homologated_inscription?.status
        );
      }
      return inscriptions;
    },
  },
  watch: {
    search: function (val) {
      const url = new URL(window.location);
      url.searchParams.set("busca", val);
      history.replaceState({}, "", url);
    },
    only_homologated: function (val) {
      const url = new URL(window.location);
      url.searchParams.set("apenasHomologados", val);
      history.replaceState({}, "", url);
    },
    "tableOptions.page": function (val) {
      const url = new URL(window.location);
      url.searchParams.set("pagina", val);
      history.replaceState({}, "", url);
    },
    "tableOptions.itemsPerPage": function (val) {
      const url = new URL(window.location);
      url.searchParams.set("porPagina", val);
      history.replaceState({}, "", url);
    },
    "filters.course": function (val) {
      const url = new URL(window.location);
      url.searchParams.set("curso", val);
      history.replaceState({}, "", url);
      if (
        this.ps.title !==
        "Processo Seletivo para o Curso de Mestrado em Educação - EDITAL N. 01/2021–PPGED/UNIFAP"
      ) {
        let courses = [];
        if (this.ps.courses) {
          courses.push(...this.ps.courses.map((e) => e.title));
        } else if (this.ps.subprocesses) {
          for (let i = 0; i < this.ps.subprocesses.length; i++) {
            const process = this.ps.subprocesses[i];
            courses.push(...process.courses);
          }
        }
        if (val !== "Todos") {
          this.headersAux = this.allHeaders.filter((e) => {
            if (courses.includes(e.required_field)) {
              return e.required_field === val;
            } else return e;
          });
        } else {
          this.headersAux = this.allHeaders.filter((e) => {
            if (courses.includes(e.required_field)) return false;
            else return e;
          });
        }
      }
    },
    notAnsweredBonifications: function (val) {
      if (val)
        if (this.onlyBonifications == false) this.onlyBonifications = true;
    },
  },
  components: {
    LoadingDialog,
    SetEnemGradesDialog,
    ConfirmDialog,
    InsertPaymentDialog,
    ConsolidaResultadosDialog,
    ExportDialog,
  },
  data() {
    return {
      tableOptions: { page: 1, itemsPerPage: 25 },
      paymentDialog: false,
      consolidaDialog: false,
      vacancies: [],
      confirmDialog: false,
      setEnemGradesDialog: false,
      only_homologated: false,
      filters: { course: "Todos" },
      courses: ["Todos"],
      notAnsweredBonifications: false,
      loadingDialog: false,
      exportDialog: false,
      onlyBonifications: false,
      search: "",
      ps: {},
      inscriptions: [],
      headersAux: [],
      sortBy: ["course", "vacancie.title", "id_user.name"],
      sortDesc: false,
      headers: [
        {
          text: "Nome",
          value:
            "id_user.name.usa_nome_social ? id_user.social_name : id_user.name",
        },
        { text: "CPF", value: "id_user.cpf" },
        { text: "E-mail", value: "id_user.email" },
      ],
    };
  },
  async created() {
    this.loadingDialog = true;
    await this.getInscriptionList();
    const { busca, porPagina, pagina, curso, apenasHomologados } =
      this.$router.currentRoute.query;
    if (busca) this.search = busca;
    if (curso) this.filters.course = curso;
    if (porPagina) this.tableOptions.itemsPerPage = parseInt(porPagina);
    if (pagina) this.tableOptions.page = pagina;
    if (apenasHomologados !== undefined)
      this.only_homologated = apenasHomologados;
    this.loadingDialog = false;
  },
  methods: {
    inscriptionReportPaid() {
      return inscriptionReportPaidPdf(this.ps.title, this.inscriptions);
    },
    generateInscriptionsTecnico() {
      let cursos = this.ps.subprocesses[0].courses;
      let inscriptionEndDate = new Date(this.ps.schedule[0].end);
      let inscritosTotal = {};
      for (let i = 0; i < cursos.length; i++) {
        const curso = cursos[i].title;
        let inscriptions = this.inscriptions
          .filter(
            (e) => (e.is_paid || e.accepted_isencao) && e.course === curso
          )
          .map((e) => {
            let subtracaoDataMs =
              inscriptionEndDate - this.$toDate(e.id_user.birthday);
            let subtracaoAnos = subtracaoDataMs / 31557600000;
            let dadosGerais = {
              name: e.id_user.name.usa_nome_social
                ? e.id_user.social_name
                : e.id_user.name,
              has60: subtracaoAnos >= 60 ? true : false,
              idade: e.id_user.birthday,
              course: e.course,
              vacancie: e.vacancie.title,
            };
            if (
              e.avaliationData === undefined ||
              e.avaliationData.length === 0
            ) {
              return {
                ...dadosGerais,
                notaGeral: "",
                notaEspecifica: "",
                total: "",
              };
            } else {
              return {
                ...dadosGerais,
                notaGeral: e.avaliationData[0].fields[0].input,
                notaPortugues: e.avaliationData[0].fields[1].input,
                notaLegislacao: e.avaliationData[0].fields[2].input,
                notaEspecifica: e.avaliationData[0].fields[3].input,
                total: e.avaliationData[0].total,
              };
            }
          })
          .sort(
            firstBy((a, b) => a.course.localeCompare(b.course), {
              direction: "asc",
            })
              .thenBy("total", { direction: "desc" })
              .thenBy("notaEspecifica", { direction: "desc" })
              .thenBy("notaPortugues", { direction: "desc" })
              .thenBy("notaGeral", { direction: "desc" })
              .thenBy("notaLegislacao", { direction: "desc" })
              .thenBy("idade", { direction: "asc" })
              .thenBy((a, b) => a.name.localeCompare(b.name), {
                direction: "asc",
              })
          );

        let inscriptionsNaoCortados = inscriptions.filter(
          (e) => e.notaGeral >= 15 && e.notaEspecifica >= 15
        );

        // let inscriptionsCortados = inscriptions.filter(
        //   (e) => e.notaGeral < 15 || e.notaEspecifica < 15
        // );
        // console.log(inscriptionsNaoCortados, inscriptionsCortados, inscriptions)

        let inscriptionsArrumado = [
          ...inscriptionsNaoCortados,
          // ...inscriptionsCortados,
        ];
        inscritosTotal[curso] = {
          vacancies: cursos[i].vacancies,
          inscriptions: inscriptionsArrumado,
        };
        // inscriptionsArrumado.forEach(e => console.log(`${curso} - Nascimento: ${e.idade} - Tem 60: ${e.has60} - Específica: ${e.notaEspecifica} - Portugues: ${e.notaPortugues} - Legislacao: ${e.notaLegislacao} - Geral: ${e.notaGeral} - Total: ${e.total} - Vaga: ${e.vacancie}`))
      }
      generateResultadoTecnico(
        this.ps.title,
        inscritosTotal,
        this.ps.subprocesses[0].vacancies
      );
    },
    generateConfirmedInscriptions() {
      const inscriptions = this.inscriptions
        .map((e) => {
          return {
            name: e.id_user.name,
            course: e.course,
            status:
              e.is_paid || e.accepted_isencao
                ? "INSCRIÇÃO CONFIRMADA"
                : "INSCRIÇÃO NÃO CONFIRMADA",
          };
        })
        .sort(
          firstBy((a, b) => a.course.localeCompare(b.course), {
            direction: "asc",
          })
            .thenBy((a, b) => a.name.localeCompare(b.name), {
              direction: "asc",
            })
            .thenBy("status", { direction: "desc" })
        );
      return generateConfirmedInscriptionsPdf(this.ps.title, inscriptions);
    },
    generateInscriptionReport() {
      return generateInscriptionReport(this.ps, this.inscriptions);
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    isCops() {
      if (this.ps.cops) {
        const cops = this.ps.cops.filter((e) => e === this.user._id);
        if (cops.length > 0) {
          return true;
        }
      }
      return false;
    },
    formataTelefone(telefone) {
      const ddd = telefone.substring(0, 2);
      const first = telefone.substring(2, 7);
      const last = telefone.substring(7);
      return `(${ddd}) ${first}-${last}`;
    },
    setHeader(toggle, header) {
      header.model = !header.model;
      toggle();
    },
    inscriptionDetails(e) {
      // VAI PARA DETALHES
      const path = `/processos/${this.ps._id}/inscricao-detalhes/${e._id}`;
      this.$router.push(path);
    },
    generateInscriptionPdf(inscription_type, is_bonification_list) {
      this.loadingDialog = true;
      const title = this.ps.title;
      let sorted;
      if (is_bonification_list) {
        if (this.ps.is_paid)
          sorted = this.inscriptions.filter(
            (e) =>
              e.bonification?.multiplier > 1 &&
              (e.is_paid || e.accepted_isencao)
          );
        else
          sorted = this.inscriptions.filter(
            (e) => e.bonification?.multiplier > 1
          );
      } else {
        sorted = this.inscriptions;
      }
      sorted = sortArray(sorted, {
        by: ["curso", "vaga", "name"],
        order: "asc",
        computed: {
          name: (row) => row.id_user.name,
          curso: (row) => this.$courseHandler(row.course),
          vaga: (row) =>
            row.vacancie && row.vacancie.title
              ? row.vacancie.title
              : "Ampla Concorrência",
        },
      });
      if (inscription_type === "all" && is_bonification_list) {
        this.loadingDialog = false;
        return generateInscriptionPdf(
          title + " - SOLICITAÇÕES DE BONIFICAÇÃO",
          sorted,
          true
        );
      } else if (inscription_type === "all") {
        this.loadingDialog = false;
        return generateInscriptionPdf(title + " - TODOS OS INSCRITOS", sorted);
      } else if (inscription_type === "wants_isencao") {
        const wants_isencao_list = this.inscriptions.filter(
          (e) => e.wants_isencao
        );
        this.loadingDialog = false;
        return generateInscriptionPdf(
          title + " - SOLICITAÇÕES DE ISENÇÃO",
          wants_isencao_list
        );
      } else if (inscription_type === "accepted_isencao") {
        const accepted_isencao_list = this.inscriptions.filter(
          (e) => e.accepted_isencao
        );
        this.loadingDialog = false;
        return generateInscriptionPdf(
          title + " - ISENÇÕES ACEITAS",
          accepted_isencao_list
        );
      }
    },
    async generateNoGradeXlsx() {
      const inscriptions = await app.service("inscriptions").find({
        query: {
          id_ps: this.ps._id,
          enem: { $exists: false },
          $populate: ["id_user", "id_avaliator"],
        },
      });
      const insData = inscriptions.map((e) => {
        return [e.id_user.name, this.$formatCpf(e.id_user.cpf)];
      });
      let planilha = xlsx.utils.book_new();
      let cabecalho = [["NOME", "CPF"]];
      let conteudo = [...cabecalho, ...insData];
      let ws = xlsx.utils.aoa_to_sheet(conteudo);
      planilha.SheetNames.push("Candidatos");
      planilha.Sheets["Candidatos"] = ws;
      let wbout = xlsx.write(planilha, { bookType: "xls", type: "binary" });
      saveAs(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        `${this.ps.title} - candidatos sem nota.xls`
      );
    },
    openConfirmDialog() {
      this.confirmDialog = true;
    },
    async setAvaliatorsAuto(result) {
      if (result) {
        this.confirmDialog = false;
        this.loadingDialog = true;
        try {
          await app.service("set-avaliators").create({
            id_ps: this.ps._id,
            inscriptions: this.inscriptionsInTable,
          });
          await this.getInscriptionList();
          this.errorMsg = false;
          this.snackbarMsg = "Operação realizada com sucesso.";
          this.snackbar = true;
        } catch (error) {
          this.errorMsg = true;
          this.snackbarMsg =
            "Falha ao realizar operação, por favor tente novamente.";
          this.snackbar = true;
        }
        this.loadingDialog = false;
      }
    },
    async getInscriptionList() {
      const ps_id = this.$router.currentRoute.params.id;
      const ps = await app.service("selective-processes").get(ps_id);
      this.ps = ps;
      let courses = [];
      if (this.ps.courses) {
        courses.push(...this.ps.courses.map((e) => e.title));
      } else if (this.ps.subprocesses) {
        for (let i = 0; i < this.ps.subprocesses.length; i++) {
          const process = this.ps.subprocesses[i];
          courses.push(...process.courses.map((e) => e.title));
        }
      }
      this.courses.push(...courses.sort((a, b) => a > b));

      let inscriptions = await app.service("inscriptions").find({
        query: { id_ps: ps_id, $populate: ["id_user", "id_avaliator"] },
      });

      this.inscriptions = inscriptions;
      // const errados = inscriptions.filter((e) => !e.vacancie?.title)
      // for (const errado of errados) {
      //   await app.service('inscriptions').patch(errado._id, {
      //     id_ps: errado.id_ps,
      //     vacancie: { title: 'Ampla Concorrência' },
      //   })
      // }
      this.vacancies = {
        "Ampla concorrência": [],
        "Renda Inferior a 1,5 SM PPI DEF": [],
        "Renda Inferior a 1,5 SM PPI NDEF": [],
        "Renda Inferior a 1,5 SM NPPI DEF": [],
        "Renda Inferior a 1,5 SM NPPI NDEF": [],
        "Renda Superior a 1,5 SM PPI DEF": [],
        "Renda Superior a 1,5 SM PPI NDEF": [],
        "Renda Superior a 1,5 SM NPPI DEF": [],
        "Renda Superior a 1,5 SM NPPI NDEF": [],
      };
      // for (const inscription of inscriptions) {
      //   this.vacancies[inscription.vacancie.title].push(inscription);
      // }
      this.inscriptions = this.inscriptions.map((i) => {
        i.originalCourse = JSON.parse(JSON.stringify(i.course));
        i.course = this.$courseHandler(i.course);
        if (i.id_user._id) i.id_user.cpf = this.$formatCpf(i.id_user.cpf);
        i.createdAt = this.$toBrDate(i.createdAt);
        if (i.avaliationData)
          i.avaliationData.forEach((av) => {
            i[av.title] = av.input;
          });

        return i;
      });
      const defaultHeaders = [
        { text: "Número de inscrição", value: "inscriptionNumber" },
        { text: "Nome", value: "id_user.name" },
        { text: "CPF", value: "id_user.cpf" },
        { text: "E-mail", value: "id_user.email" },
        { text: "Curso Selecionado", value: "course" },
        { text: "Tipo de vaga", value: "vacancie.title" },
      ];

      const aux = [
        ...defaultHeaders,
        // ...ps.inscriptionData,
        // ...ps.avaliationData.map((a) => {
        //   a["avaliation"] = true;
        //   return a;
        // }),
        { text: "Hora da Inscrição", value: "createdAt" },
      ].map((e) => {
        e["model"] = true;
        if (
          e.text &&
          (e.text === "Nome" ||
            e.text === "CPF" ||
            e.text === "E-mail" ||
            e.text === "Número de inscrição" ||
            e.text === "Curso Selecionado" ||
            e.text === "Tipo de vaga" ||
            e.text === "Hora da Inscrição" ||
            e.text === "Avaliador responsável")
        ) {
          return e;
        }
        e["text"] = e.title;

        e["value"] = e.avaliation ? `${e.title}` : `${e.title}`;
        return e;
      });
      if (
        this.ps.title !==
        "Processo Seletivo para o Curso de Mestrado em Educação - EDITAL N. 01/2021–PPGED/UNIFAP"
      ) {
        let courses = [];
        if (this.ps.courses) {
          courses.push(...this.ps.courses.map((e) => e.title));
        } else if (this.ps.subprocesses) {
          for (let i = 0; i < this.ps.subprocesses.length; i++) {
            const process = this.ps.subprocesses[i];
            courses.push(...process.courses);
          }
        }
        this.allHeaders = JSON.parse(JSON.stringify(aux));
        this.headersAux = this.allHeaders.filter((e) => {
          if (courses.includes(e.required_field)) return false;
          else return e;
        });
      } else {
        this.inscriptions = this.inscriptions.map((e) => {
          if (e.inscriptionData)
            e.inscriptionData.forEach((i) => {
              if (i.required_field === e.course.title) {
                if (i.title.includes("1ª Opção de Orientador"))
                  e["1ª Opção de Orientador"] = i.input;
                if (i.title.includes("2ª Opção de Orientador"))
                  e["2ª Opção de Orientador"] = i.input;
                if (i.title.includes("3ª Opção de Orientador"))
                  e["3ª Opção de Orientador"] = i.input;
              }
            });
          return e;
        });
        this.allHeaders = JSON.parse(JSON.stringify(aux));
        this.headersAux = this.allHeaders.filter((e) => {
          return (
            e.title !== "1ª Opção de Orientador (Políticas Educacionais)" &&
            e.title !== "2ª Opção de Orientador (Políticas Educacionais)" &&
            e.title !== "3ª Opção de Orientador (Políticas Educacionais)" &&
            e.title !==
              "1ª Opção de Orientador (Educação, Culturas e Diversidades)" &&
            e.title !==
              "2ª Opção de Orientador (Educação, Culturas e Diversidades)" &&
            e.title !==
              "3ª Opção de Orientador (Educação, Culturas e Diversidades)"
          );
        });
        this.headersAux.splice(6, 0, {
          text: "1ª Opção de Orientador",
          model: true,
          value: "1ª Opção de Orientador",
        });
        this.headersAux.splice(7, 0, {
          text: "2ª Opção de Orientador",
          model: true,
          value: "2ª Opção de Orientador",
        });
        this.headersAux.splice(8, 0, {
          text: "3ª Opção de Orientador",
          model: true,
          value: "3ª Opção de Orientador",
        });
      }
    },
  },
};
</script>

<style lang="css" scoped>
.btn-filter {
  display: inline-block;
  text-align: center;
  font-size: 90%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 30px;
  padding-left: 30px;
  margin-top: 10px;

  margin-right: 10px;
  border-radius: 20px;
}

.btn-disabled {
  background-color: #e0e0e0;
}

.btn-enabled {
  color: white;
  background-color: #1976d2;
}

.btn-filter:hover {
  cursor: pointer;
}

.row-pointer-mobile >>> tbody tr:hover,
.row-pointer >>> tbody tr:hover {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.row-pointer-mobile::v-deep td {
  font-size: 13px !important;
}
</style>
